import { LOCALSTORAGE_KEYS } from '@constants';
import { atom } from 'recoil';
import { localStorageEffect } from './effects';

const PREFIX_KEY = 'src/atoms/lang/';

export const languageAtom = atom<string>({
  key: `${PREFIX_KEY}language.atom`,
  default: navigator.language,
  // @ts-ignore
  effects: [localStorageEffect(LOCALSTORAGE_KEYS.LANGUAGE)],
});
